import PropTypes from 'prop-types';
import React, {Component, PureComponent} from 'react';
import {HoverMixin} from 'shared/helpers/mixins';
import _ from 'lodash';
import * as Colors from 'material-ui/styles/colors';
import {getImage} from 'MyAccount/ViewDesigns/helpers/uploadHelper';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import TextField from 'material-ui/TextField';
import FlipMove from 'react-flip-move';
import RaisedButton from 'material-ui/RaisedButton';

const WEB_ADDRESS_LOADER_INITIAL_STATE = {errorMessage: null, img: null};
class WebAddressLoader extends PureComponent {
  state = WEB_ADDRESS_LOADER_INITIAL_STATE;

  componentDidMount() {
    const {initialImageProperties} = this.props;
    if (initialImageProperties && !_.isEmpty(initialImageProperties.src)) {
      this.onUrlChange();
    }
    this.autoFocus = setTimeout(() => this.refs.url.focus(), 0);
  }

  componentWillUnmount() {
    clearTimeout(this.autoFocus);
  }

  onUrlChange = _.debounce(
    () => {
      const src = this.refs.url.getValue();
      const {onUpdate} = this.props;
      const update = {src};
      if (_.isEmpty(src)) {
        this.setState(WEB_ADDRESS_LOADER_INITIAL_STATE);
        update.valid = true;
      } else {
        update.valid = false;
        getImage(src, img => {
          if (img !== null) {
            onUpdate({valid: true});
            this.setState({...WEB_ADDRESS_LOADER_INITIAL_STATE, img});
          } else {
            this.setState({
              ...WEB_ADDRESS_LOADER_INITIAL_STATE,
              errorMessage: "Oops!, We can't find an image at that URL, A typo maybe?",
            });
          }
        });
      }
      onUpdate(update);
    },
    1000,
    {leading: true, trailing: true}
  );

  getSrc() {
    return _.get(this, 'state.img.src');
  }

  autoFocus = null;

  _lastImg = null;

  render() {
    const {onDelete, initialUrl, id} = this.props;
    const {errorMessage, hovered} = this.state;
    return (
      <div
        id={id}
        onMouseEnter={HoverMixin.onMouseEnter.bind(this)}
        onMouseLeave={HoverMixin.onMouseLeave.bind(this)}
        style={{display: 'flex', alignItems: 'center', marginTop: 20, width: '100%'}}
      >
        <TextField
          id={`${id}-input`}
          style={{width: '100%'}}
          floatingLabelText="Image URL"
          hintText="Paste an image URL here"
          onChange={this.onUrlChange}
          ref="url"
          errorStyle={{float: 'left'}}
          errorText={errorMessage}
          defaultValue={initialUrl}
          autoFocus
        />
        <IconButton
          className="cla-delete"
          iconStyle={{color: Colors.grey800}}
          style={{opacity: hovered ? 1 : 0}}
          onClick={onDelete}
        >
          <FontIcon className="material-icons">delete</FontIcon>
        </IconButton>
      </div>
    );
  }
}

WebAddressLoader.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  initialUrl: PropTypes.string,
};

export class WebAddressesLoader extends PureComponent {
  state = {
    srcs: [{id: 0, src: null}],
  };

  componentDidMount() {
    const {onValidChange} = this.props;
    onValidChange(this.valid(this.state.srcs));
  }

  componentDidUpdate(prevProps, prevState) {
    const {onValidChange} = this.props;
    const valid = this.valid(this.state.srcs);
    const prevValid = this.valid(prevState.srcs);
    if (valid !== prevValid) {
      onValidChange(valid);
    }
  }

  getSrcs() {
    return _.filter(
      this.state.srcs.map(src => {
        return src.src;
      })
    );
  }

  updateSrc = (index, update) => {
    const srcs = _.clone(this.state.srcs);
    srcs[index] = {...srcs[index], ...update};
    this.setState({srcs});
    this.props.getUrls(srcs);
  };

  removeSrc = index => {
    const srcs = _.clone(this.state.srcs);
    srcs.splice(index, 1);
    this.setState({srcs});
    this.props.getUrls(srcs);
  };

  addSrc = () => {
    const srcs = _.clone(this.state.srcs);
    srcs.push({id: this._nextSrcId++, src: null, valid: true});
    this.setState({srcs});
    this.props.getUrls(srcs);
  };

  valid(srcs) {
    return (
      _.every(srcs, 'valid') &&
      _.every(srcs, src => {
        return !_.isEmpty(src.src);
      })
    );
  }

  _nextSrcId = this.state.srcs.length;

  render() {
    const {srcs} = this.state;
    const {onValidChange, style, getUrls, ...otherProps} = this.props;
    return (
      <FlipMove
        {...otherProps}
        style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: 65, ...style}}
        enterAnimation="accordianVertical"
        leaveAnimation="accordianVertical"
        onStart={() => {
          this.state.flipingInProgress = true;
        }}
        onFinishAll={() => {
          this.setState({flipingInProgress: false});
        }}
      >
        {srcs.map((src, index) => {
          return (
            <WebAddressLoader
              id={`cla-image-url-${index}`}
              initialUrl={src.src}
              key={src.id}
              onUpdate={update => {
                this.updateSrc(index, update);
              }}
              onDelete={() => {
                this.removeSrc(index);
              }}
            />
          );
        })}
        <RaisedButton
          id="cla-btn-add-image-url"
          style={{marginTop: 20, marginBottom: 20, maxHeight: 36}}
          label="add image url"
          onClick={this.addSrc}
        />
      </FlipMove>
    );
  }
}

WebAddressesLoader.defaultProps = {
  style: {},
  onValidChange: () => {},
};
